// Convierte `cv_url` en una liga que el navegador pueda abrir, para la interna.
//  - http(s)://…     → tal cual (liga que dio la fuente)
//  - demo-cv:<id>    → PDF de ejemplo generado en el navegador (modo demo)
//  - <cliente>/<x>.pdf → ruta en el bucket privado «cvs» de Supabase → liga firmada por 10 min
import { MODO } from "./modo";

export async function resolverCv(cvUrl: string | null | undefined): Promise<string | null> {
  if (!cvUrl) return null;
  if (/^https?:\/\//.test(cvUrl)) return cvUrl;
  if (cvUrl.startsWith("demo-cv:")) {
    const [{ leerDb }, { pdfDeCv }] = await Promise.all([
      import("./demo/almacen"),
      import("./demo/pdf"),
    ]);
    const id = cvUrl.slice("demo-cv:".length);
    const db = leerDb();
    const cv = db.cv_demo.find((x) => x.id === id);
    const k = db.candidatos.find((x) => x.id === id);
    return cv && k ? URL.createObjectURL(pdfDeCv(k.nombre, cv)) : null;
  }
  if (MODO === "supabase") {
    const { getSupabaseClient } = await import(
      "@/components/atomic-crm/providers/supabase/supabase"
    );
    const { data, error } = await getSupabaseClient()
      .storage.from("cvs")
      .createSignedUrl(cvUrl, 600);
    if (error) throw new Error("No se pudo abrir el CV: " + error.message);
    return data.signedUrl;
  }
  return null;
}
